import { useQuery } from '@tanstack/react-query'
import { useFetcher } from '@/provider/useFetcher'
import { apiFetch } from './api'
import type { HistoryScope } from './history.types'
import type { RunSummary } from './types'

// The list endpoint wraps the rows in a `{ runs: [...] }` envelope (unlike the
// single-run endpoint, which returns the object directly), so the response type
// is the envelope and the query unwraps it to the bare array the UI maps over.
interface RunsEnvelope {
  runs: RunSummary[]
}

// Two lenses over the same authed rows (spec §9.3):
//   personal -> the user's runs across every org they've acted in
//   org      -> every member's runs in the active org (permissive, not admin-gated)
export function useHistory(scope: HistoryScope, enabled = true) {
  const fetcher = useFetcher()

  return useQuery({
    queryKey: ['history', scope],
    enabled,
    queryFn: async ({ signal }) => {
      const res = await apiFetch<RunsEnvelope>(
        fetcher,
        `/api/runs?scope=${scope}`,
        { signal }
      )

      return res?.runs ?? []
    },
  })
}
